import React from 'react'
import {S3Image} from "../../custom-common";
import IMAGE from "../../../constants/images";

export const BrandedLogo = (props) =>
	<S3Image {...IMAGE.OFFICIAL_LOGO} {...props}/>;

